// extracted by mini-css-extract-plugin
export default {"wrapper":"pageTitle_wrapper__X-23K","back":"pageTitle_back__tAxVW"};